

























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { Product } from '@/dto';
import { ProductsState } from '@/store';
import { localize } from '@/core/filters';

@Component
export default class ProductFilter extends Vue {
    @Prop({ type: Object }) public product?: Product;

    public setCurrentProduct(product: Product): void {
        if (product) {
            ProductsState.selectProduct(product);
        }
    }

    public get icon() {
        return this.dynamicComponent('tag');
    }

    private dynamicComponent(name: string) {
        return () => import(`@/assets/icons/${name}.svg`);
    }
}
